import React, { useState, useEffect } from 'react';
import Field from './Field';
export interface BaseEditableFieldProps {
  initialValue?: string;
  onSave?: (value: string) => void;
  [x: string]: any;
}
export default function EditableField({
  initialValue,
  onSave,
  ...rest
}: BaseEditableFieldProps) {
  const [edit, setEdit] = useState(false);
  const [value, setValue] = useState('');

  useEffect(() => {
    if (initialValue) {
      setValue(initialValue);
    } else {
      setEdit(false);
    }
  }, [initialValue]);
  const handleBlur = (e: React.FormEvent<any>) => {
    onSave && onSave(value);
    setEdit(false);
  };
  return (
    <div className="flex justify-between items-center" {...rest}>
      {edit ? (
        <Field
          autoFocus
          value={value}
          onChange={(e: any) => setValue(e.target.value)}
          onBlur={handleBlur}
        />
      ) : (
        <span
          id="question"
          onDoubleClick={() => {
            setEdit(true);
          }}
        >
          {initialValue}
        </span>
      )}
    </div>
  );
}
